import { IEngagement } from "@wingspanhq/payments/dist/interfaces";
import { WSInfiniteQueryConfig } from "@ws-react-query";

import { useXWingspanPayerId } from "../../../modules/Payees/routes/RoutePayeeDetails/useXWingspanPayerId";
import {
  EngagementApiFilter,
  EngagementFilter,
  getEngagements
} from "../../../services/engagements";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSInfiniteQuery } from "../../helpers";
import { QUERY_ENGAGEMENT_LIST } from "../keys";

export function mapEngagementsFilters(filters?: EngagementFilter) {
  const filter: EngagementApiFilter = {};

  if (filters?.type) {
    filter.type = filters.type;
  }

  if (filters?.status) {
    filter.status = filters.status;
  }

  if (filters && "isDefault" in filters) {
    filter.isDefault = filters.isDefault;
  }

  return filter;
}

export type EngagementListQueryParams = {
  sort?: {
    updatedAt?: "desc" | "asc";
    createdAt?: "desc" | "asc";
    status?: "desc" | "asc";
  };
  filter?: EngagementFilter;
  payeeId?: string;
  page?: {
    size?: number;
  };
};

const DEFAULT_PAGE_SIZE = 10;

export const useQueryEngagementList = (
  params?: EngagementListQueryParams,
  config?: WSInfiniteQueryConfig<IEngagement[], WSServiceError>
) => {
  const { sort, filter, page } = params || {};
  const size = page?.size ?? DEFAULT_PAGE_SIZE;

  const xWingspanPayerId = useXWingspanPayerId();

  return useWSInfiniteQuery<IEngagement[], WSServiceError>(
    [QUERY_ENGAGEMENT_LIST, params, xWingspanPayerId],
    async ({ pageParam = 1 }) => {
      const { data } = await getEngagements(
        {
          filter: mapEngagementsFilters(filter),
          page: { number: pageParam, size },
          sort
        },
        xWingspanPayerId
      );

      return data;
    },
    {
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage.length < size) {
          return undefined;
        }

        return allPages.length + 1;
      },
      ...config
    }
  );
};
